import React, { useEffect, useState } from 'react';
import {
  Grid,
  Tabs,
  Tab,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Divider
} from '@mui/material';
import {
  getCells,
  sendNotification,
  setSelectedCell
} from '../../actions/orderActions';
import { newNotification } from '../../actions/uiActions';
import { connect } from 'react-redux';
import ProductsTable from './InventoryTable';
import Partners from './Partners';
import SpecialOffersTable from './SpecialOffersTable';
import AppDisplayTable from './AppDisplayTable';
import Notifications from './Notifications';
import AutoActionsTable from './components/AutoActionsTable';
import StoresTable from './components/StoresTable';
import AppBanners from './AppBanners';
import { days } from 'utils/parsingUtils';
import getTabConfig from '../../getUserRolesForTabs';
import AutomaticNotifications from './AutomaticNotifications';

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}
const NotificationsPageIndex = 0
const AppDisplayTablePageIndex = 1
const ProductsTablePageIndex = 2
const SpecialOffersTablePageIndex = 3
const AutoActionsTablePageIndex = 4
const AppBannersIndex = 5
const PartnersPageIndex = 6
const AutomaticNotificationsPageIndex = 7

const Commercial = ({
  cells,
  notify,
  sendNotification,
  getCells,
  selectedCellId,
  setSelectedCell
}) => {
  const [currentTab, setCurrentTab] = useState(0);
  const [tabConfig, setTabConfig] = useState([]);
  const currentDay = days[new Date().getDay()];

  const handleChangeCell = evt => {
    setSelectedCell(evt.target.value);
  };

  useEffect(() => {
    getTabConfig('Commercial').then(setTabConfig);
    getCells();
  }, []);

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ');
  }
  return (
    <Grid container style={{ height: '100%' }}>
      <div style={{ padding: '24px', width: '100%', height: '100%' }}>
        <div className="flex flex-col gap-2 items-start">
          <div className="sm:hidden border border-mannamono-line py-2 rounded">
            <label htmlFor="tabs" className="sr-only">
              Select a tab
            </label>

            <select
              id="tabs"
              name="tabs"
              defaultValue={
                tabConfig.length > 0 ? tabConfig[currentTab].title : undefined
              }
              onChange={event => {
                setCurrentTab(parseInt(event.target.value));
              }}
              className="block w-full rounded-md border-gray-300 py-2 pl-3 pr-2 text-base focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm">
              {tabConfig.map(tab => (
                <option key={tab.title} value={tab.index}>
                  {tab.title}
                </option>
              ))}
            </select>
          </div>
          <div className="hidden sm:block">
            <div className="border-b border-gray-200">
              <nav aria-label="Tabs" className="-mb-px flex space-x-8">
                {tabConfig.map(tab => (
                  <button
                    key={tab.title}
                    aria-current={
                      tab.index == tabConfig[currentTab].index
                        ? 'page'
                        : undefined
                    }
                    onClick={() => {
                      setCurrentTab(tab.index);
                    }}
                    className={classNames(
                      tab.index == tabConfig[currentTab].index
                        ? 'border-mannablue-default text-mannablue-default'
                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                      'whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium'
                    )}>
                    {tab.title}
                  </button>
                ))}
              </nav>
            </div>
          </div>
          <Grid item>
            <FormControl fullWidth style={{ width: 200 }}>
              <InputLabel>Cell</InputLabel>
              <Select
                value={selectedCellId}
                label="Cell"
                onChange={handleChangeCell}>
                {cells?.map(cell => {
                  return (
                    <MenuItem key={`cell-${cell.id}`} value={cell.id}>
                      {cell.cellName}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
          </Grid>
        </div>
        {currentTab === NotificationsPageIndex && (
          <div style={{ paddingTop: 25 }}>
            <Notifications cells={cells} cellId={selectedCellId} />
          </div>
        )}
        {currentTab === AppDisplayTablePageIndex && (
          <div style={{ paddingTop: 25 }}>
            <AppDisplayTable cellId={selectedCellId} />
          </div>
        )}
        {currentTab === ProductsTablePageIndex && (
          <div style={{ paddingTop: 25 }}>
            <ProductsTable cellId={selectedCellId} />
          </div>
        )}
        {currentTab === SpecialOffersTablePageIndex && (
          <div style={{ paddingTop: 25 }}>
            <SpecialOffersTable cellId={selectedCellId} />
          </div>
        )}
        {currentTab === AutoActionsTablePageIndex && (
          <div style={{ paddingTop: 25 }}>
            <div style={{ marginTop: 20, marginBottom: 30 }}>
              <AutoActionsTable notify={notify} day={currentDay} />
            </div>
            <Divider />
            <div style={{ marginTop: 20, marginBottom: 30 }}>
              <StoresTable notify={notify} />
            </div>
          </div>
        )}
        {currentTab === PartnersPageIndex && (
          <div style={{ paddingTop: 25 }}>
            <div style={{ marginTop: 20, marginBottom: 30 }}>
              <Partners cellId={selectedCellId} />
            </div>
          </div>
        )}
        {currentTab === AppBannersIndex && (
          <div style={{ paddingTop: 25 }}>
            <div style={{ marginTop: 20, marginBottom: 30 }}>
              <AppBanners
                cellId={selectedCellId}
                timezone={cells?.find(c => c.id === selectedCellId)?.timezone}
              />
            </div>
          </div>
        )}
        {currentTab === AutomaticNotificationsPageIndex && (
          <div style={{ paddingTop: 25 }}>
            <div style={{ marginTop: 20, marginBottom: 30 }}>
              <AutomaticNotifications cellId={selectedCellId} />
            </div>
          </div>
        )}
      </div>
    </Grid>
  );
};

const mapStateToProps = state => ({
  cells: state.orders.cells,
  selectedCellId: state.orders.selectedCellId
});

const mapDispatchToProps = dispatch => ({
  getCells: () => dispatch(getCells()),
  notify: notification => dispatch(newNotification(notification)),
  sendNotification: notif => dispatch(sendNotification(notif)),
  setSelectedCell: cellId => dispatch(setSelectedCell(cellId))
});

export default connect(mapStateToProps, mapDispatchToProps)(Commercial);